module.exports = __webpack_public_path__ + "static/media/480.652456c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-birch/light/480.png
// module id = 1892
// module chunks = 2